module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/node_modules/core-js/modules/_iterators.js
// module id = 60
// module chunks = 1